import React, { useState } from "react";
import { Button, Control, Field, Input } from "@allxsmith/bestax-bulma";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { createSetDataFreshAction } from "../../../actions/dataActions";
import { getDataFresh } from "../../../state/selectors";

function VehicleTypeRow({
  vehicleTypeData,
  index,
  onVehicleTypeUpdate,
  endpoint
}) {
  const dispatch = useDispatch();
  const [vehicleType, setVehicleType] = useState(vehicleTypeData);
  const [editable, setEditable] = useState(false);
  let dataFresh = useSelector(getDataFresh);

  const submitUpdate = e => {
    e.stopPropagation();
    const url = endpoint + "vehicletype/" + vehicleType.id;
    const conf = {
      method: "put",
      data: vehicleType,
      url
    };

    axios(conf).then(() => {
      setEditable(false);
      dispatch(createSetDataFreshAction(dataFresh + 1));
    });
  };

  const onChange = e => {
    let newVehicleType = { ...vehicleType };
    newVehicleType[e.target.name] = e.target.value || null;
    setVehicleType(newVehicleType);
    onVehicleTypeUpdate(index, newVehicleType);
  };

  const onEdit = e => {
    e.stopPropagation();
    setEditable(!editable);
  };

  const onDelete = e => {
    const url = endpoint + "vehicletype/" + vehicleType.id;
    const conf = { method: "delete", url };
    axios(conf).then(response =>
      dispatch(createSetDataFreshAction(dataFresh + 1))
    );
  };

  return (
    <tr key={vehicleTypeData.id}>
      <td>
        <Field onClick={e => e.stopPropagation()} className="has-addons">
          <Control>
            <Input
              onChange={onChange}
              type="text"
              name="name"
              value={vehicleType.name}
              disabled={!editable}
            />
          </Control>
          {editable ? (
            <Control>
              <Button color="success" onClick={submitUpdate}>
                Save
              </Button>
            </Control>
          ) : (
            <Control>
              <Button onClick={onEdit}>Edit</Button>
            </Control>
          )}
        </Field>
      </td>
      <td>
        <Field onClick={e => e.stopPropagation()} className="has-addons">
          <Control>
            <Input
              onChange={onChange}
              type="text"
              name="special_labour_rate"
              value={
                editable
                  ? vehicleType.special_labour_rate
                  : vehicleType.special_labour_rate
                    ? parseFloat(vehicleType.special_labour_rate).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }
                    )
                    : undefined
              }
              disabled={!editable}
            />
          </Control>
          {editable ? (
            <Control>
              <Button color="success" onClick={submitUpdate}>
                Save
              </Button>
            </Control>
          ) : (
            <Control>
              <Button onClick={onEdit}>Edit</Button>
            </Control>
          )}
        </Field>
      </td>
      <td>
        <Field onClick={e => e.stopPropagation()} className="has-addons">
          <Control>
            <Input
              onChange={onChange}
              type="text"
              name="fixed_hire_costs"
              value={
                editable
                  ? vehicleType.fixed_hire_costs
                  : vehicleType.fixed_hire_costs
                    ? parseFloat(vehicleType.fixed_hire_costs).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }
                    )
                    : undefined
              }
              disabled={!editable}
            />
          </Control>
          {editable ? (
            <Control>
              <Button color="success" onClick={submitUpdate}>
                Save
              </Button>
            </Control>
          ) : (
            <Control>
              <Button onClick={onEdit}>Edit</Button>
            </Control>
          )}
        </Field>
      </td>
      <td className={"is-narrow"}>
        <Button color={"danger"} onClick={onDelete}>
          Delete X
        </Button>
      </td>
    </tr>
  );
}

export default VehicleTypeRow;
